<app-dialog-header>
    <app-dialog-title>
        {{ data.title }}
    </app-dialog-title>
</app-dialog-header>

<form [formGroup]="form"
      (ngSubmit)="request()"
      autocomplete="off">

    <mat-dialog-content>
        <div [innerHTML]="data.contentHtml"></div>

        <cll-form-field [label]="data.confirmInputLabel || 'Confirm'">
            <input [formControl]="form.controls.confirm"
                   data-testid="input:confirm-carer-name"
                   cllFormInput
                   type="text" />
        </cll-form-field>

        <ng-container *ngIf="data.requirePassword && currentUser.supportsPasswordPrompts()">
            <hr>

            <cll-form-field label="Password">
                <input [formControl]="form.controls.password"
                       cllFormInput
                       data-testid="input:enter-password-to-continue"
                       placeholder="Enter password to continue"
                       type="password" />
            </cll-form-field>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button cll-button
                colour="variant"
                mat-dialog-close
                (click)="dialogRef.close()">
            Cancel
        </button>

        <button cll-filled-button
                colour="warn"
                data-testid="button:confirm-deletion"
                type="submit"
                [disabled]="form.invalid || submitting">
            {{ data.confirmText || 'Confirm' }}
        </button>
    </mat-dialog-actions>
</form>
